import { useApiBlob } from '../api-blob'
import { useApiForm } from '../api-form'
import { urlArgs } from '../state'

// export const useApiFormChunkUploadContent = args => useApiForm(process.env.REACT_APP_API_STORAGE, `api/ddd/chunk-upload-content${urlArgs(args)}`)
// export const useApiFormChunkUploadBuild = args => useApiForm(process.env.REACT_APP_API_STORAGE, `api/ddd/chunk-upload-build${urlArgs(args)}`)
// export const useApiFormFileBuildChunk = args => useApiForm(process.env.REACT_APP_API_STORAGE, `api/ddd/file-build-chunk${urlArgs(args)}`)
export const useApiFormFileContentChunk = args => useApiForm(process.env.REACT_APP_API_STORAGE, `api/v1/file-content-chunk${urlArgs(args)}`)

export const useApiFormFilePublic = args => useApiForm(process.env.REACT_APP_API_STORAGE, `api/v1/file-public${urlArgs(args)}`)
export const useApiBlobFilePublic = args => useApiBlob(process.env.REACT_APP_API_STORAGE, `api/v1/file-public${urlArgs(args)}`)

export const useApiFormFileTradeshow = args => useApiForm(process.env.REACT_APP_API_STORAGE, `api/v1/file-tradeshow${urlArgs(args)}`)
export const useApiBlobFileTradeshow = args => useApiBlob(process.env.REACT_APP_API_STORAGE, `api/v1/file-tradeshow${urlArgs(args)}`)

export const useApiFormFileSelfRegister = args => useApiForm(process.env.REACT_APP_API_STORAGE, `api/v1/file-self-register${urlArgs(args)}`)
export const useApiBlobFileSelfRegister = args => useApiBlob(process.env.REACT_APP_API_STORAGE, `api/v1/file-self-register${urlArgs(args)}`)

export const useApiFormFileBuild = args => useApiForm(process.env.REACT_APP_API_STORAGE, `api/v1/file-build${urlArgs(args)}`)
export const useApiBlobFileBuild = args => useApiBlob(process.env.REACT_APP_API_STORAGE, `api/v1/file-build${urlArgs(args)}`)

export const useApiFormFileContent = args => useApiForm(process.env.REACT_APP_API_STORAGE, `api/v1/file-content${urlArgs(args)}`)
export const useApiBlobFileContent = args => useApiBlob(process.env.REACT_APP_API_STORAGE, `api/v1/file-content${urlArgs(args)}`)

export const useApiFormFileAI = args => useApiForm(process.env.REACT_APP_API_STORAGE, `api/v1/file-ai${urlArgs(args)}`)
